import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Estado } from '../../shared/models/system';
import { environment } from '../../../environments/environment.dev';
import { Auth } from './auth.service';

@Injectable({ providedIn: 'root' })
export class EstadosService {
  private apiUrl = `${environment.apiUrl}/estados`;

  constructor(private http: HttpClient, private auth: Auth) {}

  private getHeaders() {
    const token = this.auth.getToken();
    return {
      headers: new HttpHeaders({ 'Authorization': `Bearer ${token}` })
    };
  }

  getAll(): Observable<Estado[]> {
    return this.http.get<Estado[]>(`${this.apiUrl}`, this.getHeaders());
  }

  getActive(): Observable<Estado[]> {
    return this.http.get<Estado[]>(`${this.apiUrl}/active`, this.getHeaders());
  }

  create(estado: Partial<Estado>): Observable<Estado> {
    return this.http.post<Estado>(`${this.apiUrl}`, estado, this.getHeaders());
  }

  update(id: number, estado: Estado): Observable<Estado> {
    return this.http.put<Estado>(`${this.apiUrl}/${id}`, estado, this.getHeaders());
  }

  toggle(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, this.getHeaders());
  }
}
